export const userRoles = {
  CLIENT: 'Cliente',
  PROVIDER: 'Proveedor',
  MANAGER: 'Gestor',
  ADMINISTRATOR: 'Administrador'
}

export const dateTimeFormat = 'DD/MM/YYYY HH:mm'
export const dateFormat = 'DD/MM/YYYY'
